import { render, staticRenderFns } from "./RequestInvoiceDesktop.vue?vue&type=template&id=2c14a776&"
import script from "./RequestInvoiceDesktop.vue?vue&type=script&lang=js&"
export * from "./RequestInvoiceDesktop.vue?vue&type=script&lang=js&"
import style0 from "./RequestInvoiceDesktop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VChip,VCol,VDivider,VIcon,VRow,VSimpleTable})
